import store from '../../store/store';

import('./type_selector.scss');

export default function TypeSelector(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    this.generate = () =>{
        elements.container = this.createElement('div', 'type-selector-container')
        elements.btn_plu = this.createElement('div', 'type-selector-item', '<div class="icon"><i class="fas fa-cloud-showers-heavy"></i></div><div class="text">Chuva</div>')
        elements.btn_flu = this.createElement('div', 'type-selector-item', '<div class="icon"><i class="fas fa-water"></i></div><div class="text">Nível</div>')
        $(elements.container).append(elements.btn_plu, elements.btn_flu)

        store.mainConfigStore.subscribe('TYPE_UPDATE', type =>{
            $(elements.btn_plu).toggleClass('active', type==='plu')
            $(elements.btn_flu).toggleClass('active', type==='flu')
        })

        $(elements.btn_plu).on('click', _ =>{
            store.mainConfigStore.setType('plu')
        })

        $(elements.btn_flu).on('click', _ =>{
            store.mainConfigStore.setType('flu')
        })

        return elements.container
    }

    this.update = () =>{

    }
}

TypeSelector.prototype = Object.create(BaseConstructor.prototype)